import React, { useState, useEffect, useContext, useMemo } from "react";
import TextInput from "components/Input/TextInput.js";
import {
  CustomSelect,
} from "components/Input/Index.js";
import Button from "components/CustomButtons/Button.js";
import EditButton from "components/CustomButtons/Button.js";
import { makeStyles, withStyles } from "@mui/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import uuid from "react-uuid";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

import styled from "styled-components";
import Chip from "@mui/material/Chip";
import Dialog from "@mui/material/Dialog";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";

import AdvancedSearchContext from "context/AdvancedSearchContext";
import { vuepagetext } from "variables/vues";

import DataTable from "react-data-table-component";
import _ from "lodash";

import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";

import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import ViewEditionDialog from "./ViewEditionDialog";
import AddIcon from "@mui/icons-material/Add";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const useStyles2 = makeStyles(styles);
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "28ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "28ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;
const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;
const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

function CategoryEditionDialog(props) {
  const memv2versionactive = localStorage.getItem('memv2version') || 0;
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const { closeModal, refetch, setLoading, currentCategory, chartsList, setModification } = props;

  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = advancedSearchContext;

  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [name, setName] = useState(currentCategory?.name || "");
  const [views, setViews] = useState([]);
  const [currentview, setCurrentview] = useState("");
  const [openview, setOpenview] = useState(false);

  const handleNameChange = (event) => {
    setName(event.target.value);
    currentCategory.name = event.target.value;
    setModification(true);
  };

  const classes = useStyles();
  const classes2 = useStyles2();

  const handleSubmit = (event) => {

  };

  useEffect(() => {
    if (currentCategory && currentCategory.views) {
      let tmpdata = currentCategory.views;
      let position = 1;
      tmpdata.forEach((view) => {
        if (!view.uuid) {
          view.uuid = uuid();
        }
        if (!view.position) {
          view.position = position;
          position++;
        }
      });
      setViews(tmpdata);

      currentCategory.views = tmpdata;
    }
    
  }, []);

  useEffect(() => {
    if (!name)
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  });

  const upView = (row) => async () => {
    let newviews = [...views];
    let obj = newviews.find((o) => o.uuid === row.uuid);
    let oldposition = obj.position;
    let newposition = oldposition - 1; //ie 3 -> 2
    let replacedchart = newviews.find((o) => o.position === newposition);
    obj.position = newposition;
    replacedchart.position = oldposition;
    setViews(newviews);
    currentCategory.views = newviews;
    setModification(true);
  };

  const downView = (row) => async () => {
    let newviews = [...views];
    let obj = newviews.find((o) => o.uuid === row.uuid);
    let oldposition = obj.position;
    let newposition = oldposition + 1; //ie 3 -> 4
    let replacedchart = newviews.find((o) => o.position === newposition);
    obj.position = newposition;
    replacedchart.position = oldposition;
    setViews(newviews);
    currentCategory.views = newviews;
    setModification(true);
  };
  /*VIEWS TAB*/
  const viewscolumns = [
    {
      name: vuepagetext.position,
      selector: (row) => row.position,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.position || ""
    },
    {
      name: vuepagetext.viewname,
      selector: (row) => row.viewName,
      sortable: true,
      cell: (row) => row.viewName
    },
    {
      name: vuepagetext.columns,
      selector: (row) => row.column,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.column
    },
    // {
    //   name: campaignviewtext.datebegin,
    //   selector: (row) => row.parameters.general.datebegin,
    //   sortable: true,
    //   maxWidth: "10rem",
    //   cell: (row) =>
    //     row.parameters.general.datebegin && moment(row.parameters.general.datebegin).isValid()
    //       ? moment(row.parameters.general.datebegin).format("DD/MM/YYYY")
    //       : "",
    // },
    // {
    //   name: campaignviewtext.dateend,
    //   selector: (row) => row.parameters.general.dateend,
    //   sortable: true,
    //   maxWidth: "10rem",
    //   cell: (row) =>
    //     row.parameters.general.dateend && moment(row.parameters.general.dateend).isValid()
    //       ? moment(row.parameters.general.dateend).format("DD/MM/YYYY")
    //       : "",
    // },
    {
      name: vuepagetext.chartscount,
      selector: (row) => row.charts.length,
      sortable: true,
      maxWidth: "8rem",
      cell: (row) => row.charts.length
    },
    // {
    //   name: campaignviewtext.groups,
    //   selector: (row) => row.parameters.general.groups,
    //   sortable: true,
    //   cell: (row) => groupInfoListById["" + row.parameters.general.groups] || ""
    // },
    {
      name: "",
      sortable: false,
      width: "12rem",
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title="Monter la position">
              <EditButton
                onClick={upView(row)}
                color={"info"}
                className={classes2.actionButton}
                disabled={row.position == 1}
              >
                <ArrowDropUpIcon fontSize="large" />
              </EditButton>
            </Tooltip>
            <Tooltip title="Descendre la position">
              <EditButton
                onClick={downView(row)}
                color={"info"}
                className={classes2.actionButton}
                disabled={row.position == views.length}
              >
                <ArrowDropDownIcon fontSize="large" />
              </EditButton>
            </Tooltip>
            <Tooltip title="Editer la vue">
              <EditButton
                onClick={editCategoryView(row)}
                color={"warning"}
                className={classes2.actionButton}
              >
                <EditIcon fontSize="large" />
              </EditButton>
            </Tooltip>
            <Tooltip title="Supprimer la vue de la catégorie">
              <CustomDeleteButton
                deleteTitle={"Suppression de la vue"}
                deleteSubTitle={`Êtes-vous sûr de vouloir supprimer la vue '${row.viewName}' de la catégorie?`}
                handleSupprimer={deleteViewFromCategoryFunction(row)}
              />
            </Tooltip>
          </div>
        </>
      ),
    },
  ]



  const handleClickOpenView = () => {
    setOpenview(true);
  };
  const handleEditCloseView = () => {
    if (!currentview.viewName)
      currentview.viewName = 'Nouvelle vue';
    if (!currentview.column)
      currentview.column = 2;
    setOpenview(false);
  };

  const editCategoryView = (row) => async () => {
    let obj = views.find((o) => o.uuid === row.uuid);
    if (obj) {
      setCurrentview(obj);
      handleClickOpenView();
    }
  }
  const deleteViewFromCategoryFunction = (row) => async () => {
    let obj = views.find((o) => o.uuid === row.uuid);
    if (obj) {
      let newviews = [...views];
      newviews.forEach((view) => {
        if (view.position > obj.position) {
          view.position = view.position - 1;
        }
      });
      newviews = views.filter((o) => o.uuid !== row.uuid);
      setViews(newviews);
      currentCategory.views = newviews;
      setModification(true);
    }

  };

  const AddView = () => {
    let newView = {
      uuid: uuid(),
      viewName: 'Nouvelle vue',
      charts: [],
      column: 2,
      position: views.length + 1,
    };
    let tmpdata = [...views];
    tmpdata.push(newView);
    console.log(tmpdata);
    setViews(tmpdata);
    currentCategory.views = tmpdata;
    setCurrentview(newView);
    handleClickOpenView();
    setModification(true);
  };

  const [filterTextView, setFilterTextView] = useState("");
  const [resetPaginationToggleView, setResetPaginationToggleView] = useState(false);
  const SearchComponentView = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItemsView = views.filter(
    (item) =>
      (item.viewName && item.viewName.toLowerCase().includes(filterTextView.toLowerCase()))
  );
  const subHeaderComponentMemoView = useMemo(() => {
    const handleClearView = () => {
      if (filterTextView) {
        setResetPaginationToggleView(!resetPaginationToggleView);
        setFilterTextView("");
      }
    };
    const onFilterTextView = (e) => setFilterTextView(e.target.value);

    return (
      <>
        <TableName>Vues de la catégorie</TableName>
        <SearchComponentView
          key="SearchComponentView"
          onFilter={onFilterTextView}
          onClear={handleClearView}
          filterText={filterTextView}
        />

        <UploadButton type="button" onClick={handleClearView}>
          <Tooltip title="Ajouter une vue">
            <Button
              onClick={AddView}
              color={"success"}
              className={classes2.actionButton}
            >
              <AddIcon fontSize="large" />
            </Button>
          </Tooltip>
        </UploadButton>

      </>
    );
  }, [filterTextView, resetPaginationToggleView, views, currentCategory]);

  return (
    <>
      <CustomDialogTitle id="customized-dialog-title" onClose={closeModal}>
        {'Edition de la catégorie ' + currentCategory?.name}
      </CustomDialogTitle>
      <DialogContent dividers style={{ height: "90vh" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <GridContainer>
              <GridItem xs={12} sm={6} md={7} lg={7}>
                <div>
                  <TextInput
                    isRequired
                    inputTitle={vuepagetext.categoryname}
                    textInput={name}
                    handleTextInputChange={handleNameChange}
                  />
                </div>
              </GridItem>
            </GridContainer>
          </GridItem>

          <GridItem xs={12} sm={12} md={12}>
            <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
              noDataComponent={<NoData>{"Aucune vue"}</NoData>}
              noHeader={true}
              columns={viewscolumns}
              persistTableHead
              pagination
              subHeader
              data={filteredItemsView}
              paginationComponentOptions={{
                noRowsPerPage: false,
                rowsPerPageText: "Lignes par page",
                rangeSeparatorText: "sur",
                selectAllRowsItem: false,
                selectAllRowsItemText: "Selectionner toutes les lignes",
              }}
              defaultPageSize={10}
              filterable={true}
              defaultSortFieldId={1}
              manual={true}
              paginationResetDefaultPage={resetPaginationToggleView}
              subHeaderComponent={subHeaderComponentMemoView}
            />
          </GridItem>
        </GridContainer>
      </DialogContent>
      {/* <DialogActions>
        <Button
          disabled={buttonDisabled}
          className={
            buttonDisabled
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Valider
        </Button>
      </DialogActions> */}
      <Dialog
        onClose={handleEditCloseView}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={openview}
      >
        <ViewEditionDialog
          currentView={currentview}
          closeModal={handleEditCloseView}
          chartsList={chartsList}
          setViews={setViews}
          views={views}
          setModification={setModification}
        // refetch={refreshTableView}
        />
      </Dialog>
    </>
  );
}

export default CategoryEditionDialog;
